    <div class="row">
        <div class="col-md-offset-3 col-md-3">
            <form>
                <mat-form-field class="setup-form-full-width">
                    <mat-select (selectionChange)="customerChanged($event)" name="customer" [(ngModel)]="_currentSelection.customer" placeholder="{{Translate('Select Customer')}}">
                        <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList" [value]="customer">
                            {{ customer.Title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="setup-form-full-width">
                    <mat-select (selectionChange)="jobsiteChanged($event)" name="jobsite" [(ngModel)]="_currentSelection.jobSite" placeholder="{{Translate('Select Job Site')}}">
                        <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList" [value]="jobsite">
                            {{ jobsite.Title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="setup-form-full-width">
                    <mat-select (selectionChange)="equipmentChanged($event)" name="equipment" placeholder="{{Translate('Select Equipment')}}">
                        <mat-option *ngFor="let equipment of _dropDownListsFiltered.equipmentList" [value]="equipment">
                            {{ equipment.Serial+ ' : ' + equipment.Unit }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
        </div>
        <div class="fix-control-area">
            <a mat-raised-button routerLink="/">Cancel</a> <button mat-raised-button color="warn" (click)="submit()">{{Translate('Next')}}</button>
        </div>
    </div>
